import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import AuthService from './AuthService';
import formatDate from '../formatDate';

interface IAuthState {
    // token: string | null;
    tokenRefreshedTime: string | null,
    isAuthenticated: boolean;
    loading: boolean;
    error: string | null;
    errorStatus: number | null;
}

const initialState: IAuthState = {
    // token: localStorage.getItem('token'),
    tokenRefreshedTime: localStorage.getItem("tokenRefreshedTime"),
    isAuthenticated: !!localStorage.getItem('isAuthenticated'),
    loading: false,
    error: null,
    errorStatus: null
}

export const login = createAsyncThunk(
    'auth/login',
    async (credentials: { email: string; password: string, otp: number }, { rejectWithValue }) => {
      try {
        const response = await AuthService.login(credentials);
        return response.access;
      } catch (error: any) {
        return rejectWithValue({
          message: error.response?.data?.message || 'Login failed',
          status: error.response?.status,
        });
      }
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder
          .addCase(login.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(login.fulfilled, (state, action: PayloadAction<string>) => {
            state.loading = false;
            // state.token = action.payload;

            const currentDate = formatDate(new Date())

            state.tokenRefreshedTime = currentDate
            state.isAuthenticated = true;

            // localStorage.setItem('token', action.payload);
            localStorage.setItem('tokenRefreshedTime', currentDate);
            localStorage.setItem('isAuthenticated', "true");
          })
          .addCase(login.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.message;
            state.errorStatus = action.payload.status;
          });
      },
})

export const {  } = authSlice.actions;
export default authSlice.reducer;